export const MAIN_FAQ_TEST_IDS = {
  // ─── FAQ Section ───
  sectionContainer: 'main-faq-section-container',
  sectionIcon: 'main-faq-section-icon',
  sectionTitle: 'main-faq-section-title',
  sectionSubtitle: 'main-faq-section-subtitle',
  ctaButton: 'main-faq-cta-btn',

  // ─── FAQ Cards ───
  cardsGrid: 'main-faq-cards-grid',
  card: (index: number) => `main-faq-card-${index}`,
  cardImage: (index: number) => `main-faq-card-image-${index}`,
  cardTitle: (index: number) => `main-faq-card-title-${index}`,
  cardDescription: (index: number) => `main-faq-card-description-${index}`,
  cardLink: (index: number) => `main-faq-card-link-${index}`,

  // ─── Show More / Show Less ───
  showMoreButton: 'main-faq-show-more-btn',
} as const;
